import {Accordion, Text} from '@volkswagen-onehub/components-core';
import React, {useState} from 'react';

interface FilterAccordionInterface {
  label: string;
}

function FilterAccordion({
  label,
  children,
}: React.PropsWithChildren<FilterAccordionInterface>) {
  const id = label.replace(" ", "-").toLowerCase();
  const headline = <Text bold>{label}</Text>;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleClick = () => setIsOpen((prev) => !prev);

  return (
    <Accordion
      id={id}
      headline={headline}
      isOpen={isOpen}
      onClick={handleClick}
      fullWidthBody
    >
      {children}
    </Accordion>
  );
}

export default FilterAccordion;
